import { WizardPage } from '../../components/wizard/types';
import {
    RequestToVaryDeclarationModel,
} from '../../api/models';
import { FieldModel } from '../../components/form/pageForm/types';
import { titleSelectInputProps } from '../CommonComponentProps';

const authorisedInfoText = 'I am authorised to declare on behalf of <RnDEntityName> that <RnDEntityName> requests to vary its application to register for the R&D Tax Incentive for the income period <incomePeriod>';

const hasAcceptedDeclaration: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'checkbox',
    legend: 'I declare that:',
    label: authorisedInfoText,
    name: 'hasAcceptedDeclaration',
    contentKey: ['rtovDeclaration'],
    maxWidth: '22rem',
};

const declarantLabel: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'labelSubHeading',
    label: 'Declarant details',
    name: 'declarantLabel',
    contentKey: ['rtovDeclarantDetails'],
};

const declarantTitle = titleSelectInputProps('declarantTitle', 'Title (optional)', true);
const declarantTitleOther: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'textInput',
    label: 'Other title',
    name: 'declarantTitleOther',
    maxWidth: '10rem',
    maxLength: 30,
};

const declarantFirstName: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'textInput',
    label: 'First name',
    name: 'declarantFirstName',
    maxWidth: '22rem',
    maxLength: 50,
};
const declarantLastName: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'textInput',
    label: 'Last name',
    name: 'declarantLastName',
    maxWidth: '22rem',
    maxLength: 50,
};
const declarantEmail: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'textInput',
    label: 'Email',
    name: 'declarantEmail',
    maxWidth: '16.25rem',
    maxLength: 100,
    contentKey: ['ContactDetailsEmail'],
};
const declarantPhone: FieldModel<RequestToVaryDeclarationModel> = {
    component: 'textInput',
    label: 'Phone',
    name: 'declarantPhone',
    maxWidth: '22rem',
    maxLength: 320,
    contentKey: ['rtovPhoneNumber'],
};

const requestToVaryDeclaration: WizardPage<RequestToVaryDeclarationModel> = {
    apiEndpoint: '/request-to-vary-declaration',
    name: 'requestToVaryDeclaration',
    title: 'Declaration and submit',
    fields: {
        hasAcceptedDeclaration,
        declarantLabel,
        declarantTitle,
        declarantTitleOther,
        declarantFirstName,
        declarantLastName,
        declarantEmail,
        declarantPhone,
    },
    initialPageValues: {
        hasAcceptedDeclaration: undefined,
        declarantTitle: undefined,
        declarantTitleOther: '',
        declarantFirstName: undefined,
        declarantLastName: undefined,
        declarantEmail: undefined,
        declarantPhone: undefined,
    },
    showSubmitConfirmationModal: true,
};

export default requestToVaryDeclaration;
